

export enum EntityArt {
  Unbekannt,

  Traeger,
  TraegerGruppe,
  TraegerRegister,

  Kontakt,
  KontaktType,

  Verband,
  Landkreis,
  Jugendamt,
  Rechtsform,
  Angebotsgruppe,
  Angebotsform,
  Benutzer,
  Ausbildung,
  Taetigkeit,
  Grund,
  Verwaltungsgericht,
  EoEKatalog,
  Dokument,
  RechtsgrundlageUnterbringung,

  Einrichtung,
  HauptEinrichtung,
  UnterEinrichtung,
  Einrichtungspersonal,

  StaticVorlagen,
  DynamicVorlagen,

  Meldepflichten,
  MeldepflichtenTraegerAnschrift,
  MeldepflichtenEinrichtungSchliessung,
  MeldepflichtenKontakte,
  MeldepflichtenKonzeption,
  MeldepflichtenLeitung,
  MeldepflichtenBetreuung,


  MeldungenJaehrlich,
  MeldungenJaehrlichUnterEinrichtungen,
  MeldungenJaehrlichUnterEinrichtungenStichtagPerson,
  MeldungenJaehrlichUnterEinrichtungenEntlassungenPerson,
  MeldungenJaehrlichUnterEinrichtungenAufnahmePerson,
  MeldungenJaehrlichUnterEinrichtungenBetreuungPerson,

  MeldungenEoE,

  AntragBe,
  AntragBeEinrichtungsteile,
  AntragBePersonal,
  AntragBeMitarbeiter,
  AntragBeMitarbeiterLebenslauf,

  Erlaubnis,
  Mitarbeiter,

  Antrag_Anerkennung,
  Antrag_Ueberbelegung,
  Antrag_Ueberbelegung_Personen,

  Ausnahme,
  Antrag_Kind4Jhr,
  MeldepflichtenKontakteEinrichtung,

  Antrag_Uma,
  Antrag_Verweildauer,
  Antrag_Unterschreitung,
  OldHaupteinrichtung
}


export namespace EntityArt {
  export function keys(): any[] {
    const values = Object.values(EntityArt) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      results.push({ id: i, name: values[i] });
    }

    return results;
  }

  export function getValues(): EntityArt[] {
    const values = Object.values(EntityArt) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      results.push(values[i]);
    }

    return results;
  }

  export function shortKey(eArt: EntityArt): string {
    let result = '';
    const _eArt = EntityArt[eArt];
    switch (_eArt) {
      case 'Traeger':
        result = 'Träger';
        break;
      case 'Einrichtung':
        result = 'Einrichtung';
        break;
      case 'HauptEinrichtung':
        result = 'Einrichtung';
        break;
      case 'UnterEinrichtung':
        result = 'Einrichtung';
        break;
      case 'TraegerRegister':
        result = 'Träger-Registrierung';
        break;
      case 'AntragBe':
        result = 'Antrag-BE';
        break;
      case 'Grund':
        result = 'Grund';
        break;
      case 'MeldepflichtenTraegerAnschrift':
        result = 'Mpf. Anschrift';
        break;
      case 'MeldepflichtenEinrichtungSchliessung':
        result = 'Mpf. Schliessung';
        break;
      case 'MeldepflichtenKontakte':
        result = 'Mpf. Träger-Kontakte';
        break;
      case 'MeldepflichtenKonzeption':
        result = 'Mpf. Konzeption';
        break;
      case 'MeldepflichtenLeitung':
        result = 'Mpf. Leitung';
        break;
      case 'MeldepflichtenBetreuung':
        result = 'Mpf. Betreuung';
        break;
      case 'MeldepflichtenKontakteEinrichtung':
        result = 'Mpf. Einrichtungs-Kontakte';
        break;
      case 'Einrichtungspersonal':
        result = 'Personal';
        break;
      case 'MeldungenJaehrlich':
        result = 'Jährliche Meldung';
        break;
      case 'MeldungenEoE':
        result = 'Meldung-EoE';
        break;
      case 'Antrag_Ueberbelegung':
        result = 'Antrag-Überbelegung';
        break;
      case 'Antrag_Anerkennung':
        result = 'Antrag-Anrechnung Personen';
        break;
      case 'Antrag_Kind4Jhr':
        result = 'Antrag Kind unter 4 Jahre';
        break;
      case 'Antrag_Uma':
        result = 'Antrag Unterbringung UMA';
        break;
      case 'Antrag_Verweildauer':
        result = 'Antrag längere Verweildauer KJND/Notdienste';
        break;
      case 'Antrag_Unterschreitung':
        result = 'Antrag Unterschreitung Aufnahmealter';
        break;
      case 'Erlaubnis':
        result = 'Erlaubnis';
        break;
      case 'OldHaupteinrichtung':
        result = 'Alte HE';
        break;
      default:
        result = eArt.toString();
        break;
    }
    return result;
  }
}

//export namespace EntityArt {
//    export function shortkeys(): any[] {
//        var values = Object.values(EntityArt);
//        var results = [];
//        for (let i = 0; i < values.length - 1; i++) {
//            results.push({ id: i, name: values[i].replace('_', ' ') })
//        }

//        return results;
//    }
//}
